var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadDownloadCloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "11.3,14.4 8.9,12 6.5,14.4  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.9,
    y1: 18.6,
    x2: 8.9,
    y2: 12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "12.4,18.6 14.8,20.9 17.2,18.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.8,
    y1: 14.3,
    x2: 14.8,
    y2: 20.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.9,18.1c2.3-1.6,2.8-4.7,1.2-7C21.2,9.8,19.6,9,18,9h-1.3C15.6,4.7,11.3,2.1,7,3.2S0.1,8.7,1.2,13 c0.3,1.2,0.9,2.4,1.8,3.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDownloadCloud);
export default __webpack_public_path__ + "static/media/upload-download-cloud.ad3c7f981989f78746f84d3874d920bb.svg";
export { ForwardRef as ReactComponent };